import * as React from "react";
import { Link } from "react-router-dom";
import { navbarLinks } from "src/navbarLinks";

export function Navbar(props) {
	return (
	<div id="header">
		<input id="menu-toggle" type="checkbox" />
		<nav className="navbar">
			<ul id="navlist">

				{navbarLinks.map(link => {
					return (
					<li key={link.text.toLowerCase().replaceAll(" ", "_")}>
						<Link className="linkbutton" style={link.style || undefined} to={link.externalLink ? link.path : "/"+link.path}>
						<span className={"navbar-link" + (link.text == "Our Journey" ? " hide-on-mobile" : "")}>
							{link.text}
						</span>
						{link.text == "Our Journey" && <span className="show-on-mobile navbar-link">Timeline</span>}
						</Link>
						
						<div className='line-animation'/>
					</li>
					)
				})}

			</ul>
		</nav>
	</div>)
}